var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { ContentContainer, Divider, DropdownTrigger, HamburgerDropdown, IconFrame, MenuItem, MenuLink, Wrapper } from './subcomponents';
const HamburgerMenu = (_a) => {
    var { isOpen, heightFromTop, items, children, className, closeMenu } = _a, props = __rest(_a, ["isOpen", "heightFromTop", "items", "children", "className", "closeMenu"]);
    const location = useLocation();
    const { pathname } = location;
    const getHasRouteMatchChild = (menuItems) => {
        return menuItems.some((item) => {
            const { relPath, shouldHighlight = true } = item;
            return relPath === pathname && shouldHighlight;
        });
    };
    const wrapperRef = useRef(null);
    const handleClickOutside = (event) => {
        var _a, _b, _c;
        const originalTarget = event.target.shadowRoot
            ? ((_a = event.path) === null || _a === void 0 ? void 0 : _a[0]) || ((_c = (_b = event.composedPath) === null || _b === void 0 ? void 0 : _b.call(event)) === null || _c === void 0 ? void 0 : _c[0])
            : event.target;
        if (wrapperRef.current &&
            !wrapperRef.current.contains(originalTarget) &&
            isOpen) {
            event.stopImmediatePropagation();
            closeMenu();
        }
    };
    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    });
    return (React.createElement(Wrapper, Object.assign({}, props, { ref: wrapperRef }),
        React.createElement(ContentContainer, { isOpen: isOpen, heightFromTop: heightFromTop, className: className },
            isOpen &&
                items.map((item, index) => {
                    const { isDropdown, icon, content, relPath, dataType, dataReason } = item;
                    if (!isDropdown) {
                        return (React.createElement(MenuLink, { to: relPath, key: `${index + 1}`, "data-type": dataType, "data-reason": dataReason, className: dataType && 'ensightencustomevent', "data-object": dataType && 'link', onClick: closeMenu },
                            React.createElement(MenuItem, { hasActiveStyles: relPath === pathname },
                                icon && React.createElement(IconFrame, null, icon),
                                content)));
                    }
                    const { menuClosedIcon, menuOpenIcon, dropdownItems } = item;
                    return (React.createElement(HamburgerDropdown, { key: `${index + 1}`, containerPosition: "relative", trigger: React.createElement(DropdownTrigger, { label: content, icon: icon, hasActiveStyles: false, dataType: dataType, dataReason: dataReason, menuClosedIcon: menuClosedIcon, menuOpenIcon: menuOpenIcon, hasRouteMatchChild: getHasRouteMatchChild(dropdownItems) }) }, dropdownItems.map(({ relPath: childPath, content: childContent, shouldHighlight = true, dataType: childDataType, dataReason: childDataReason }, i) => {
                        return (React.createElement(MenuLink, { to: childPath, "data-type": childDataType, "data-reason": childDataReason, className: childDataType && 'ensightencustomevent', "data-object": childDataType && 'link', onClick: closeMenu, key: `${i + 1}` },
                            React.createElement(MenuItem, { hasActiveStyles: childPath === pathname && shouldHighlight, isDropdownItem: true }, childContent)));
                    })));
                }),
            React.createElement(Divider, null),
            children)));
};
export default HamburgerMenu;
